module.exports = function getResource(label, vars = []) {
    const resources = {
        relevancy: 'Pertinence',
        bestselling: 'Meilleurs vendeurs',
        topRated: 'Meilleur classement',
        exclusive: 'Exclusivement',
        new: 'Nouveauté',
        priceDesc: 'Par ordre décroissant de prix',
        priceAsc: 'Par ordre croissant de prix',
        brandName: 'Nom de la marque'
    };

    return resources[label];
};
